import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux/es/exports";
import { Link } from "react-router-dom";
import LOGO from "../../assets/images/logos/logo.png";
import { resetChartOfAccountState } from "../../redux/slice/accounting/accountingSlice";
import { logout, resetAuth } from "../../redux/slice/auth/authSlice";
import { resetCustomers } from "../../redux/slice/customer/customerSlice";
import { resetOffices } from "../../redux/slice/office/officeSlice";
import { resetRolesStatus } from "../../redux/slice/roles/roleSlice";
import { resetStaffRecords } from "../../redux/slice/staff/staffSlice";
import { resetUsers } from "../../redux/slice/user/userSlice";
import { toggleSidebar } from "../../utils/helpers/toggleNavbar";
import { resetPolicy } from "../../redux/slice/policy/policySlice";
import { resetPolicy as resetSavingsPolicy } from "../../redux/slice/policy/savingsPolicy/savingsPolicySlice";
import { resetCommission } from "../../redux/slice/commission/commissionSlice";
import { resetDash } from "../../redux/slice/dash/dashSlice";
import { resetReport } from "../../redux/slice/report/reportSlice";
import { resetUnderwriting } from "../../redux/slice/underwriting/underwritingSlice";
import { BiNetworkChart } from "react-icons/bi";
import { resetWorkflow } from "../../redux/slice/workflow/workflowSlice";
import { resetClaim } from "../../redux/slice/claim/claimSlice";

const Sidenav = () => {
  const [isMinimized, setIsMinimized] = useState(false);
  const dispatch = useDispatch();

  const [hasCustomerModule, setHasCustomerModule] = useState(null);
  const [hasCustomerDashboard, setHasCustomerDashboard] = useState(null);
  const [viewCustomerCorporate, setViewCustomerCorporate] = useState(null);
  const [viewCustomerIndividual, setViewCustomerIndividual] = useState(null);
  const [hasOfficeModule, setHasOfficeModule] = useState(null);
  const [hasStaffModule, setHasStaffModule] = useState(null);
  const [hasUserModule, setHasUserModule] = useState(null);
  const [hasSettingsModule, setHasSettingsModule] = useState(null);
  const [hasClauseModule, setHasClauseModule] = useState(null);
  const [hasRolesModule, setHasRolesModule] = useState(null);
  const [hasCommissionModule, setHasCommissionModule] = useState(null);
  const [hasPolicyConfigModule, setHasPolicyConfigModule] = useState(null);
  const [hasAccountingModule, setHasAccountingModule] = useState(null);
  const [hasPolicyModule, setHasPolicyModule] = useState(null);
  const [hasReportModule, setHasReportModule] = useState(null);
  const [hasWorkflowModule, setHasWorkflowModule] = useState(null);
  const [hasFormModule, setHasFormModule] = useState(null);
  const [hasCoverModule, setHasCoverModule] = useState(null);
  const [hasClaimConfigModule, setHasClaimConfigModule] = useState(null);
  const [hasClaimModule, setHasClaimModule] = useState(null);
  const [hasInitiateClaim, setHasInitiateClaim] = useState(null);
  const [hasJournals, setHasJournals] = useState(null);
  const [hasChartOfAccounts, setHasChartOfAccounts] = useState(null);

  const { user } = useSelector((state) => state.auth);
  const { user: user_info } = user;

  // const paginated_office = useSelector((state) => state.office.offices);
  // const officePageNumber = paginated_office?.paginated?.current_page;

  const logoutHandler = async () => {
    dispatch(resetStaffRecords());
    dispatch(resetOffices());
    dispatch(resetPolicy());
    dispatch(resetAuth());
    dispatch(resetUsers());
    dispatch(resetCustomers());
    dispatch(resetChartOfAccountState());
    dispatch(resetRolesStatus());
    dispatch(resetCommission());
    dispatch(resetDash());
    dispatch(resetReport());
    dispatch(resetUnderwriting());
    dispatch(resetClaim());
    dispatch(resetWorkflow());
    dispatch(resetClaim());
    dispatch(resetSavingsPolicy());
    dispatch(logout(user_info.id));
  };

  // console.log(user?.user_permissions);

  useEffect(() => {
    setHasCustomerModule(
      user?.user_permissions?.some(
        (permission) => permission.name === "customer module"
      )
    );
    setHasCustomerDashboard(
      user?.user_permissions?.some(
        (permission) => permission.name === "customer dashboard"
      )
    );
    setViewCustomerCorporate(
      user?.user_permissions?.some(
        (permission) => permission.name === "view customers - corporate"
      )
    );
    setViewCustomerIndividual(
      user?.user_permissions?.some(
        (permission) => permission.name === "view customers - individual"
      )
    );
    setHasOfficeModule(
      user?.user_permissions?.some(
        (permission) => permission.name === "office module"
      )
    );
    setHasStaffModule(
      user?.user_permissions?.some(
        (permission) => permission.name === "staff module"
      )
    );
    setHasUserModule(
      user?.user_permissions?.some(
        (permission) => permission.name === "user module"
      )
    );
    setHasSettingsModule(
      user?.user_permissions?.some(
        (permission) => permission.name === "settings module"
      )
    );
    setHasClauseModule(
      user?.user_permissions?.some(
        (permission) => permission.name === "clause module"
      )
    );
    setHasRolesModule(
      user?.user_permissions?.some(
        (permission) => permission.name === "roles/permissions module"
      )
    );
    setHasCommissionModule(
      user?.user_permissions?.some(
        (permission) => permission.name === "commission module"
      )
    );
    setHasPolicyConfigModule(
      user?.user_permissions?.some(
        (permission) => permission.name === "policy configuration module"
      )
    );
    setHasAccountingModule(
      user?.user_permissions?.some(
        (permission) => permission.name === "accounting module"
      )
    );
    setHasPolicyModule(
      user?.user_permissions?.some(
        (permission) => permission.name === "policy module"
      )
    );
    setHasReportModule(
      user?.user_permissions?.some(
        (permission) => permission.name === "customer report module"
      )
    );
    setHasWorkflowModule(
      user?.user_permissions?.some(
        (permission) => permission.name === "workflow module"
      )
    );
    setHasFormModule(
      user?.user_permissions?.some(
        (permission) => permission.name === "custom form module"
      )
    );
    setHasCoverModule(
      user?.user_permissions?.some(
        (permission) => permission.name === "cover module"
      )
    );
    setHasClaimConfigModule(
      user?.user_permissions?.some(
        (permission) => permission.name === "claim configuration module"
      )
    );
    setHasClaimModule(
      user?.user_permissions?.some(
        (permission) => permission.name === "claim module"
      )
    );
    setHasInitiateClaim(
      user?.user_permissions?.some(
        (permission) => permission.name === "initiate claim"
      )
    );
    setHasChartOfAccounts(
      user?.user_permissions?.some(
        (permission) => permission.name === "charts of accounts"
      )
    );
    setHasJournals(
      user?.user_permissions?.some(
        (permission) => permission.name === "journals"
      )
    );
  }, [user?.user_permissions]);

  return (
    <>
      {/* LEFT SIDE NAV */}
      <div className="leftside-menu">
        {/* LOGO */}
        <Link to="/admin/dashboard" className="logo text-center logo-light">
          <span className="logo-lg">
            <img src={LOGO} alt="" height="50" />
            <h4
              className={`text-warning text-uppercase m-2 text-center logo-text`}
            >
              Prudent Choice
            </h4>
          </span>
          <span className="logo-sm">
            <img src={LOGO} alt="" height="40" />
          </span>
        </Link>

        <Link to="/admin/dashboard" className="logo text-center logo-dark">
          <span className="logo-lg mt-1">
            <img src={LOGO} alt="" height="50" />
            <h4
              className={`text-warning text-uppercase m-1 text-center logo-text`}
            >
              Prudent Choice
            </h4>
          </span>
          <span className="logo-sm">
            <img src={LOGO} alt="" height="40" />
          </span>
        </Link>
        {/* END LOGO */}

        <div className="h-100 mt-4" id="leftside-menu-container" data-simplebar>
          {/* Sidemenu */}
          <ul className="side-nav">
            <li className="side-nav-item">
              <Link
                to="/admin/dashboard"
                onClick={() => {
                  toggleSidebar();
                  setIsMinimized(!isMinimized);
                }}
                className="side-nav-link"
              >
                <i className="uil-home-alt"></i>
                {/* <span className='badge bg-success float-end'>4</span> */}
                <span> Dashboard </span>
              </Link>
            </li>

            {/* <li className="side-nav-title side-nav-item">Pages</li> */}

            {hasCustomerModule && (
              <li className="side-nav-item">
                <a
                  data-bs-toggle="collapse"
                  href="#sidebarEmail"
                  aria-expanded="false"
                  aria-controls="sidebarEmail"
                  className="side-nav-link"
                >
                  <i className="uil-user-plus"></i>
                  <span> Customers </span>
                  <span className="menu-arrow"></span>
                </a>
                <div className="collapse" id="sidebarEmail">
                  <ul className="side-nav-second-level">
                    {/* {hasCustomerDashboard && (
                      <li>
                        <Link to='/admin/customer-overview'> Overview </Link>
                      </li>
                    )} */}
                    {viewCustomerIndividual && (
                      <li>
                        <Link to="/admin/individual-customers">
                          Individual Customers
                        </Link>
                      </li>
                    )}
                    {viewCustomerCorporate && (
                      <li>
                        <Link to="/admin/corporate-customers">
                          Corporate Customers
                        </Link>
                      </li>
                    )}
                  </ul>
                </div>
              </li>
            )}

            {hasPolicyModule && (
              // <li className='side-nav-item'>
              //   <Link to='/admin/applied-policies' className='side-nav-link'>
              //     <i className='uil-briefcase'></i>
              //     <span> All Policies</span>
              //   </Link>
              // </li>

              <>
                <li className="side-nav-item">
                  <a
                    data-bs-toggle="collapse"
                    href="#allpolicies"
                    aria-expanded="false"
                    aria-controls="allpolicies"
                    className="side-nav-link"
                  >
                    <i className="uil-briefcase"></i>
                    <span> All Policies</span>
                    <span className="menu-arrow"></span>
                  </a>
                  <div className="collapse" id="allpolicies">
                    <ul className="side-nav-second-level">
                      <li>
                        <Link to="/admin/all-applied-general-policies">
                          General Policy
                        </Link>
                      </li>
                      <li>
                        <Link to="/admin/all-applied-savings-policies">
                          Savings Policy
                        </Link>
                      </li>
                    </ul>
                  </div>
                </li>
              </>
            )}

            {/* {hasAccountingModule && (
              <li className='side-nav-item'>
                <Link to='/admin/accounting' className='side-nav-link'>
                  <i className='uil-money-stack'></i>
                  <span> Accounting</span>
                </Link>
              </li>
            )} */}

            {hasAccountingModule && (
              <>
                <li className="side-nav-item">
                  <a
                    data-bs-toggle="collapse"
                    href="#accounting"
                    aria-expanded="false"
                    aria-controls="accounting"
                    className="side-nav-link"
                  >
                    <i className="uil-money-stack"></i>
                    <span> Accounting</span>
                    <span className="menu-arrow"></span>
                  </a>
                  <div className="collapse" id="accounting">
                    <ul className="side-nav-second-level">
                      {hasChartOfAccounts && (
                        <li>
                          <Link to="/admin/accounting/chart-of-accounts">
                            Chart of Accounts
                          </Link>
                        </li>
                      )}
                      {hasJournals && (
                        <li>
                          <Link to="accounting/journals">Journals</Link>
                        </li>
                      )}
                    </ul>
                  </div>
                </li>
              </>
            )}

            {hasOfficeModule && (
              <li className="side-nav-item">
                <Link to="/admin/office-list" className="side-nav-link">
                  <i className="mdi mdi-office-building"></i>
                  <span> Offices </span>
                </Link>
              </li>
            )}

            {hasStaffModule && (
              <li className="side-nav-item">
                <Link to="/admin/list-of-staffs" className="side-nav-link">
                  <i className="uil-users-alt"></i>
                  <span> Staff </span>
                </Link>
              </li>
            )}

            {hasUserModule && (
              <li className="side-nav-item">
                <Link to="/admin/all-users" className="side-nav-link">
                  <i className="uil-user"></i>
                  <span> Users</span>
                </Link>
              </li>
            )}
            {hasClaimModule && (
              <>
                <li className="side-nav-item">
                  <a
                    data-bs-toggle="collapse"
                    href="#claims"
                    aria-expanded="false"
                    aria-controls="claims"
                    className="side-nav-link"
                  >
                    <i className="uil-briefcase"></i>
                    <span> Claims </span>
                    <span className="menu-arrow"></span>
                  </a>
                  <div className="collapse" id="claims">
                    <ul className="side-nav-second-level">
                      <>
                        <li className="side-nav-item">
                          <a
                            data-bs-toggle="collapse"
                            href="#allclaims"
                            aria-expanded="false"
                            aria-controls="allclaims"
                            className="side-nav-link"
                          >
                            <span>All Claims</span>
                            <span className="menu-arrow"></span>
                          </a>
                          <div className="collapse" id="allclaims">
                            <ul className="side-nav-third-level">
                              <li>
                                <Link to="/admin/claims/all-claims">
                                  General Policy
                                </Link>
                              </li>
                              <li>
                                <Link to="/admin/claims/all-savings-claims">
                                  Savings Policy
                                </Link>
                              </li>
                            </ul>
                          </div>
                        </li>
                      </>
                      {hasInitiateClaim && (
                        <>
                          <li className="side-nav-item">
                            <a
                              data-bs-toggle="collapse"
                              href="#initiateClaim"
                              aria-expanded="false"
                              aria-controls="initiateClaim"
                              className="side-nav-link"
                            >
                              <span>Initiate Claim</span>
                              <span className="menu-arrow"></span>
                            </a>
                            <div className="collapse" id="initiateClaim">
                              <ul className="side-nav-third-level">
                                <li>
                                  <Link to="/admin/claims">General Policy</Link>
                                </li>
                                <li>
                                  <Link to="/admin/savings-claims">
                                    Savings Policy
                                  </Link>
                                </li>
                              </ul>
                            </div>
                          </li>
                        </>
                      )}
                    </ul>
                  </div>
                </li>
              </>
            )}

            {hasWorkflowModule && (
              <li className="side-nav-item">
                <Link to="/admin/workflow" className="side-nav-link">
                  <i className="">
                    <BiNetworkChart size={18} />
                  </i>
                  <span> Workflow</span>
                </Link>
              </li>
            )}

            {hasSettingsModule && (
              <li className="side-nav-item">
                <a
                  data-bs-toggle="collapse"
                  href="#settingsSibarList"
                  aria-expanded="false"
                  aria-controls="settingsSibarList"
                  className="side-nav-link"
                >
                  <i className="uil-cog"></i>
                  <span> Settings </span>
                  <span className="menu-arrow"></span>
                </a>
                <div className="collapse" id="settingsSibarList">
                  <ul className="side-nav-second-level">
                    {hasRolesModule && (
                      <li>
                        <Link to="/admin/settings/roles">Roles/Permission</Link>
                      </li>
                    )}
                    {hasClauseModule && (
                      <>
                        <li className="side-nav-item">
                          <a
                            data-bs-toggle="collapse"
                            href="#preloadedClause"
                            aria-expanded="false"
                            aria-controls="preloadedClause"
                            className="side-nav-link"
                          >
                            {/* <i className='uil-briefcase'></i> */}
                            <span>Preloaded Clauses</span>
                            <span className="menu-arrow"></span>
                          </a>
                          <div className="collapse" id="preloadedClause">
                            <ul className="side-nav-third-level">
                              <li>
                                <Link to="/admin/settings/preloaded-clauses">
                                  General Clauses
                                </Link>
                              </li>
                              <li>
                                <Link to="/admin/settings/preloaded-savings-clauses">
                                  Savings Clauses
                                </Link>
                              </li>
                            </ul>
                          </div>
                        </li>
                      </>
                    )}
                    {/* {hasCommissionModule && (
                      <li>
                        <Link to='/admin/commissions'>Commission</Link>
                      </li>
                    )} */}
                    {hasPolicyConfigModule && (
                      <>
                        <li>
                          <a
                            data-bs-toggle="collapse"
                            href="#policyConfigurationSibarList"
                            aria-expanded="false"
                            aria-controls="policyConfigurationSibarList"
                            className="side-nav-link"
                          >
                            <span>Policy Configuration</span>
                            <span className="menu-arrow"></span>
                          </a>
                        </li>
                        <div
                          className="collapse"
                          id="policyConfigurationSibarList"
                        >
                          <ul className="side-nav-third-level">
                            <li>
                              <Link to="/admin/all-policies">
                                General Policy
                              </Link>
                            </li>

                            <li>
                              <Link to="/admin/savings-policy">
                                Savings Policy
                              </Link>
                            </li>
                            {/* <li>
                          <Link to='/admin/credit-life'>Credit Life</Link>
                        </li> */}
                          </ul>
                        </div>
                      </>
                    )}
                    {hasClaimConfigModule && (
                      <>
                        <li className="side-nav-item">
                          <a
                            data-bs-toggle="collapse"
                            href="#claimconfig"
                            aria-expanded="false"
                            aria-controls="claimconfig"
                            className="side-nav-link"
                          >
                            <span>Claim Configuration</span>
                            <span className="menu-arrow"></span>
                          </a>
                          <div className="collapse" id="claimconfig">
                            <ul className="side-nav-third-level">
                              <li>
                                <Link to="/admin/settings/claim-configuration">
                                  General Configuration
                                </Link>
                              </li>
                              <li>
                                <Link to="/admin/settings/savings-claim-configuration">
                                  Savings Configuration
                                </Link>
                              </li>
                            </ul>
                          </div>
                        </li>
                      </>
                    )}
                    {hasCoverModule && (
                      <li>
                        <Link to="/admin/settings/cover">Cover</Link>
                      </li>
                    )}
                    {hasFormModule && (
                      <li>
                        <Link to="/admin/settings/forms">Forms</Link>
                      </li>
                    )}
                    <li>
                      <Link to="/admin/settings/life-cover">Life Cover</Link>
                    </li>
                    {/* <li>
                      <Link to='/admin/settings/co-insurance'>Co-Insurance</Link>
                    </li> */}
                  </ul>
                </div>
              </li>
            )}

            <li className="side-nav-item">
              <Link to="/admin/co-insurance" className="side-nav-link">
                <i class="bi bi-motherboard"></i>
                <span> Co-insurance</span>
              </Link>
            </li>
            {hasReportModule && (
              <li className="side-nav-item">
                <Link to="/admin/reports" className="side-nav-link">
                  <i className="uil-notes"></i>
                  <span> Reports</span>
                </Link>
              </li>
            )}
            <li className="side-nav-title side-nav-item mt-1"></li>

            <li className="side-nav-item">
              <span className="side-nav-link">
                <i className="mdi mdi-logout"></i>
                <span onClick={logoutHandler} style={{ cursor: "pointer" }}>
                  {" "}
                  Logout{" "}
                </span>
              </span>
            </li>
          </ul>

          <div className="clearfix"></div>
        </div>
      </div>
      {/* LEFT SIDE NAV */}
    </>
  );
};

export default Sidenav;
